// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import antlr4 from 'antlr4';


const serializedATN = [4,0,42,528,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,
4,7,4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,
12,2,13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,
2,20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,26,7,26,2,
27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,32,2,33,7,33,2,34,
7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,2,39,7,39,2,40,7,40,2,41,7,
41,2,42,7,42,2,43,7,43,2,44,7,44,2,45,7,45,2,46,7,46,1,0,1,0,1,1,1,1,1,2,
1,2,1,3,1,3,1,4,1,4,1,5,1,5,1,6,1,6,1,7,1,7,1,8,1,8,1,9,1,9,1,10,1,10,1,
11,1,11,1,12,1,12,1,13,1,13,1,14,1,14,1,15,1,15,1,16,1,16,1,17,1,17,1,17,
1,18,1,18,1,18,1,19,1,19,1,19,1,19,3,19,140,8,19,1,20,1,20,1,20,3,20,145,
8,20,1,21,1,21,1,22,1,22,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,3,23,159,
8,23,1,24,1,24,1,24,1,24,1,24,1,24,3,24,167,8,24,1,25,1,25,1,25,1,25,1,25,
1,25,1,25,3,25,176,8,25,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,3,26,186,
8,26,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,
27,3,27,202,8,27,1,28,1,28,1,28,1,28,3,28,208,8,28,1,29,1,29,4,29,212,8,
29,11,29,12,29,213,1,29,1,29,1,30,1,30,5,30,220,8,30,10,30,12,30,223,9,30,
1,31,1,31,1,31,1,31,1,31,1,31,1,31,1,31,3,31,233,8,31,1,32,1,32,1,32,1,32,
1,32,1,32,1,32,1,32,3,32,243,8,32,1,33,1,33,1,33,1,33,1,33,1,33,1,33,1,33,
1,33,1,33,3,33,255,8,33,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,
3,34,267,8,34,1,34,3,34,270,8,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,
1,34,1,34,1,34,3,34,283,8,34,1,34,3,34,286,8,34,1,34,1,34,1,34,1,34,1,34,
1,34,1,34,1,34,1,34,1,34,1,34,3,34,299,8,34,1,34,3,34,302,8,34,1,34,3,34,
305,8,34,1,35,1,35,1,35,1,35,1,35,1,35,1,35,1,35,1,35,1,35,3,35,317,8,35,
1,35,3,35,320,8,35,1,35,1,35,1,35,1,35,1,35,1,35,1,35,1,35,1,35,1,35,1,35,
3,35,333,8,35,1,35,3,35,336,8,35,1,35,1,35,1,35,1,35,1,35,1,35,1,35,1,35,
1,35,1,35,1,35,3,35,349,8,35,1,35,3,35,352,8,35,1,35,3,35,355,8,35,1,36,
1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,
36,1,36,1,36,3,36,375,8,36,1,36,3,36,378,8,36,1,36,1,36,1,36,1,36,1,36,1,
36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,3,36,
399,8,36,1,36,3,36,402,8,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,
1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,3,36,423,8,36,1,36,3,36,
426,8,36,1,36,3,36,429,8,36,1,37,1,37,3,37,433,8,37,1,37,1,37,1,37,3,37,
438,8,37,1,37,1,37,1,37,3,37,443,8,37,1,37,3,37,446,8,37,1,38,1,38,1,38,
4,38,451,8,38,11,38,12,38,452,1,39,1,39,1,39,4,39,458,8,39,11,39,12,39,459,
1,40,1,40,1,40,4,40,465,8,40,11,40,12,40,466,1,41,3,41,470,8,41,1,41,5,41,
473,8,41,10,41,12,41,476,9,41,1,41,1,41,4,41,480,8,41,11,41,12,41,481,1,
41,3,41,485,8,41,3,41,487,8,41,1,42,3,42,490,8,42,1,42,4,42,493,8,42,11,
42,12,42,494,1,43,4,43,498,8,43,11,43,12,43,499,1,43,1,43,1,44,1,44,1,44,
1,44,5,44,508,8,44,10,44,12,44,511,9,44,1,44,1,44,1,44,1,44,1,44,1,45,1,
45,3,45,520,8,45,1,45,4,45,523,8,45,11,45,12,45,524,1,46,1,46,1,509,0,47,
1,1,3,2,5,3,7,4,9,5,11,6,13,7,15,8,17,9,19,10,21,11,23,12,25,13,27,14,29,
15,31,16,33,17,35,18,37,19,39,20,41,21,43,22,45,23,47,24,49,25,51,26,53,
27,55,28,57,29,59,30,61,31,63,32,65,33,67,34,69,35,71,36,73,37,75,38,77,
0,79,0,81,0,83,39,85,40,87,41,89,42,91,0,93,0,1,0,10,1,0,93,93,3,0,65,90,
95,95,97,122,4,0,48,57,65,90,95,95,97,122,1,0,96,96,1,0,34,34,1,0,39,39,
3,0,9,10,13,13,32,32,2,0,69,69,101,101,2,0,43,43,45,45,1,0,48,57,584,0,1,
1,0,0,0,0,3,1,0,0,0,0,5,1,0,0,0,0,7,1,0,0,0,0,9,1,0,0,0,0,11,1,0,0,0,0,13,
1,0,0,0,0,15,1,0,0,0,0,17,1,0,0,0,0,19,1,0,0,0,0,21,1,0,0,0,0,23,1,0,0,0,
0,25,1,0,0,0,0,27,1,0,0,0,0,29,1,0,0,0,0,31,1,0,0,0,0,33,1,0,0,0,0,35,1,
0,0,0,0,37,1,0,0,0,0,39,1,0,0,0,0,41,1,0,0,0,0,43,1,0,0,0,0,45,1,0,0,0,0,
47,1,0,0,0,0,49,1,0,0,0,0,51,1,0,0,0,0,53,1,0,0,0,0,55,1,0,0,0,0,57,1,0,
0,0,0,59,1,0,0,0,0,61,1,0,0,0,0,63,1,0,0,0,0,65,1,0,0,0,0,67,1,0,0,0,0,69,
1,0,0,0,0,71,1,0,0,0,0,73,1,0,0,0,0,75,1,0,0,0,0,83,1,0,0,0,0,85,1,0,0,0,
0,87,1,0,0,0,0,89,1,0,0,0,1,95,1,0,0,0,3,97,1,0,0,0,5,99,1,0,0,0,7,101,1,
0,0,0,9,103,1,0,0,0,11,105,1,0,0,0,13,107,1,0,0,0,15,109,1,0,0,0,17,111,
1,0,0,0,19,113,1,0,0,0,21,115,1,0,0,0,23,117,1,0,0,0,25,119,1,0,0,0,27,121,
1,0,0,0,29,123,1,0,0,0,31,125,1,0,0,0,33,127,1,0,0,0,35,129,1,0,0,0,37,132,
1,0,0,0,39,139,1,0,0,0,41,144,1,0,0,0,43,146,1,0,0,0,45,148,1,0,0,0,47,158,
1,0,0,0,49,166,1,0,0,0,51,175,1,0,0,0,53,185,1,0,0,0,55,201,1,0,0,0,57,207,
1,0,0,0,59,209,1,0,0,0,61,217,1,0,0,0,63,232,1,0,0,0,65,242,1,0,0,0,67,254,
1,0,0,0,69,304,1,0,0,0,71,354,1,0,0,0,73,428,1,0,0,0,75,445,1,0,0,0,77,450,
1,0,0,0,79,457,1,0,0,0,81,464,1,0,0,0,83,469,1,0,0,0,85,489,1,0,0,0,87,497,
1,0,0,0,89,503,1,0,0,0,91,517,1,0,0,0,93,526,1,0,0,0,95,96,5,40,0,0,96,2,
1,0,0,0,97,98,5,41,0,0,98,4,1,0,0,0,99,100,5,123,0,0,100,6,1,0,0,0,101,102,
5,125,0,0,102,8,1,0,0,0,103,104,5,91,0,0,104,10,1,0,0,0,105,106,5,93,0,0,
106,12,1,0,0,0,107,108,5,43,0,0,108,14,1,0,0,0,109,110,5,45,0,0,110,16,1,
0,0,0,111,112,5,42,0,0,112,18,1,0,0,0,113,114,5,47,0,0,114,20,1,0,0,0,115,
116,5,37,0,0,116,22,1,0,0,0,117,118,5,94,0,0,118,24,1,0,0,0,119,120,5,38,
0,0,120,26,1,0,0,0,121,122,5,58,0,0,122,28,1,0,0,0,123,124,5,63,0,0,124,
30,1,0,0,0,125,126,5,60,0,0,126,32,1,0,0,0,127,128,5,62,0,0,128,34,1,0,0,
0,129,130,5,60,0,0,130,131,5,61,0,0,131,36,1,0,0,0,132,133,5,62,0,0,133,
134,5,61,0,0,134,38,1,0,0,0,135,136,5,60,0,0,136,140,5,62,0,0,137,138,5,
33,0,0,138,140,5,61,0,0,139,135,1,0,0,0,139,137,1,0,0,0,140,40,1,0,0,0,141,
145,5,61,0,0,142,143,5,61,0,0,143,145,5,61,0,0,144,141,1,0,0,0,144,142,1,
0,0,0,145,42,1,0,0,0,146,147,5,46,0,0,147,44,1,0,0,0,148,149,5,44,0,0,149,
46,1,0,0,0,150,151,5,38,0,0,151,159,5,38,0,0,152,153,5,65,0,0,153,154,5,
78,0,0,154,159,5,68,0,0,155,156,5,97,0,0,156,157,5,110,0,0,157,159,5,100,
0,0,158,150,1,0,0,0,158,152,1,0,0,0,158,155,1,0,0,0,159,48,1,0,0,0,160,161,
5,124,0,0,161,167,5,124,0,0,162,163,5,79,0,0,163,167,5,82,0,0,164,165,5,
111,0,0,165,167,5,114,0,0,166,160,1,0,0,0,166,162,1,0,0,0,166,164,1,0,0,
0,167,50,1,0,0,0,168,176,5,33,0,0,169,170,5,78,0,0,170,171,5,79,0,0,171,
176,5,84,0,0,172,173,5,110,0,0,173,174,5,111,0,0,174,176,5,116,0,0,175,168,
1,0,0,0,175,169,1,0,0,0,175,172,1,0,0,0,176,52,1,0,0,0,177,178,5,87,0,0,
178,179,5,73,0,0,179,180,5,84,0,0,180,186,5,72,0,0,181,182,5,119,0,0,182,
183,5,105,0,0,183,184,5,116,0,0,184,186,5,104,0,0,185,177,1,0,0,0,185,181,
1,0,0,0,186,54,1,0,0,0,187,188,5,87,0,0,188,189,5,73,0,0,189,190,5,84,0,
0,190,191,5,72,0,0,191,192,5,79,0,0,192,193,5,85,0,0,193,202,5,84,0,0,194,
195,5,119,0,0,195,196,5,105,0,0,196,197,5,116,0,0,197,198,5,104,0,0,198,
199,5,111,0,0,199,200,5,117,0,0,200,202,5,116,0,0,201,187,1,0,0,0,201,194,
1,0,0,0,202,56,1,0,0,0,203,204,5,73,0,0,204,208,5,78,0,0,205,206,5,105,0,
0,206,208,5,110,0,0,207,203,1,0,0,0,207,205,1,0,0,0,208,58,1,0,0,0,209,211,
5,91,0,0,210,212,8,0,0,0,211,210,1,0,0,0,212,213,1,0,0,0,213,211,1,0,0,0,
213,214,1,0,0,0,214,215,1,0,0,0,215,216,5,93,0,0,216,60,1,0,0,0,217,221,
7,1,0,0,218,220,7,2,0,0,219,218,1,0,0,0,220,223,1,0,0,0,221,219,1,0,0,0,
221,222,1,0,0,0,222,62,1,0,0,0,223,221,1,0,0,0,224,225,5,78,0,0,225,226,
5,85,0,0,226,227,5,76,0,0,227,233,5,76,0,0,228,229,5,110,0,0,229,230,5,117,
0,0,230,231,5,108,0,0,231,233,5,108,0,0,232,224,1,0,0,0,232,228,1,0,0,0,
233,64,1,0,0,0,234,235,5,84,0,0,235,236,5,82,0,0,236,237,5,85,0,0,237,243,
5,69,0,0,238,239,5,116,0,0,239,240,5,114,0,0,240,241,5,117,0,0,241,243,5,
101,0,0,242,234,1,0,0,0,242,238,1,0,0,0,243,66,1,0,0,0,244,245,5,70,0,0,
245,246,5,65,0,0,246,247,5,76,0,0,247,248,5,83,0,0,248,255,5,69,0,0,249,
250,5,102,0,0,250,251,5,97,0,0,251,252,5,108,0,0,252,253,5,115,0,0,253,255,
5,101,0,0,254,244,1,0,0,0,254,249,1,0,0,0,255,68,1,0,0,0,256,257,5,100,0,
0,257,258,5,97,0,0,258,259,5,116,0,0,259,260,5,101,0,0,260,267,5,34,0,0,
261,262,5,68,0,0,262,263,5,65,0,0,263,264,5,84,0,0,264,265,5,69,0,0,265,
267,5,34,0,0,266,256,1,0,0,0,266,261,1,0,0,0,267,269,1,0,0,0,268,270,3,77,
38,0,269,268,1,0,0,0,269,270,1,0,0,0,270,271,1,0,0,0,271,305,5,34,0,0,272,
273,5,100,0,0,273,274,5,97,0,0,274,275,5,116,0,0,275,276,5,101,0,0,276,283,
5,34,0,0,277,278,5,68,0,0,278,279,5,65,0,0,279,280,5,84,0,0,280,281,5,69,
0,0,281,283,5,34,0,0,282,272,1,0,0,0,282,277,1,0,0,0,283,285,1,0,0,0,284,
286,3,79,39,0,285,284,1,0,0,0,285,286,1,0,0,0,286,287,1,0,0,0,287,305,5,
34,0,0,288,289,5,100,0,0,289,290,5,97,0,0,290,291,5,116,0,0,291,292,5,101,
0,0,292,299,5,39,0,0,293,294,5,68,0,0,294,295,5,65,0,0,295,296,5,84,0,0,
296,297,5,69,0,0,297,299,5,39,0,0,298,288,1,0,0,0,298,293,1,0,0,0,299,301,
1,0,0,0,300,302,3,81,40,0,301,300,1,0,0,0,301,302,1,0,0,0,302,303,1,0,0,
0,303,305,5,39,0,0,304,266,1,0,0,0,304,282,1,0,0,0,304,298,1,0,0,0,305,70,
1,0,0,0,306,307,5,116,0,0,307,308,5,105,0,0,308,309,5,109,0,0,309,310,5,
101,0,0,310,317,5,34,0,0,311,312,5,84,0,0,312,313,5,73,0,0,313,314,5,77,
0,0,314,315,5,69,0,0,315,317,5,34,0,0,316,306,1,0,0,0,316,311,1,0,0,0,317,
319,1,0,0,0,318,320,3,77,38,0,319,318,1,0,0,0,319,320,1,0,0,0,320,321,1,
0,0,0,321,355,5,34,0,0,322,323,5,116,0,0,323,324,5,105,0,0,324,325,5,109,
0,0,325,326,5,101,0,0,326,333,5,34,0,0,327,328,5,84,0,0,328,329,5,73,0,0,
329,330,5,77,0,0,330,331,5,69,0,0,331,333,5,34,0,0,332,322,1,0,0,0,332,327,
1,0,0,0,333,335,1,0,0,0,334,336,3,79,39,0,335,334,1,0,0,0,335,336,1,0,0,
0,336,337,1,0,0,0,337,355,5,34,0,0,338,339,5,116,0,0,339,340,5,105,0,0,340,
341,5,109,0,0,341,342,5,101,0,0,342,349,5,39,0,0,343,344,5,84,0,0,344,345,
5,73,0,0,345,346,5,77,0,0,346,347,5,69,0,0,347,349,5,39,0,0,348,338,1,0,
0,0,348,343,1,0,0,0,349,351,1,0,0,0,350,352,3,81,40,0,351,350,1,0,0,0,351,
352,1,0,0,0,352,353,1,0,0,0,353,355,5,39,0,0,354,316,1,0,0,0,354,332,1,0,
0,0,354,348,1,0,0,0,355,72,1,0,0,0,356,357,5,100,0,0,357,358,5,97,0,0,358,
359,5,116,0,0,359,360,5,101,0,0,360,361,5,116,0,0,361,362,5,105,0,0,362,
363,5,109,0,0,363,364,5,101,0,0,364,375,5,96,0,0,365,366,5,68,0,0,366,367,
5,65,0,0,367,368,5,84,0,0,368,369,5,69,0,0,369,370,5,84,0,0,370,371,5,73,
0,0,371,372,5,77,0,0,372,373,5,69,0,0,373,375,5,96,0,0,374,356,1,0,0,0,374,
365,1,0,0,0,375,377,1,0,0,0,376,378,3,77,38,0,377,376,1,0,0,0,377,378,1,
0,0,0,378,379,1,0,0,0,379,429,5,34,0,0,380,381,5,100,0,0,381,382,5,97,0,
0,382,383,5,116,0,0,383,384,5,101,0,0,384,385,5,116,0,0,385,386,5,105,0,
0,386,387,5,109,0,0,387,388,5,101,0,0,388,399,5,34,0,0,389,390,5,68,0,0,
390,391,5,65,0,0,391,392,5,84,0,0,392,393,5,69,0,0,393,394,5,84,0,0,394,
395,5,73,0,0,395,396,5,77,0,0,396,397,5,69,0,0,397,399,5,34,0,0,398,380,
1,0,0,0,398,389,1,0,0,0,399,401,1,0,0,0,400,402,3,79,39,0,401,400,1,0,0,
0,401,402,1,0,0,0,402,403,1,0,0,0,403,429,5,34,0,0,404,405,5,100,0,0,405,
406,5,97,0,0,406,407,5,116,0,0,407,408,5,101,0,0,408,409,5,116,0,0,409,410,
5,105,0,0,410,411,5,109,0,0,411,412,5,101,0,0,412,423,5,39,0,0,413,414,5,
68,0,0,414,415,5,65,0,0,415,416,5,84,0,0,416,417,5,69,0,0,417,418,5,84,0,
0,418,419,5,73,0,0,419,420,5,77,0,0,420,421,5,69,0,0,421,423,5,39,0,0,422,
404,1,0,0,0,422,413,1,0,0,0,423,425,1,0,0,0,424,426,3,81,40,0,425,424,1,
0,0,0,425,426,1,0,0,0,426,427,1,0,0,0,427,429,5,39,0,0,428,374,1,0,0,0,428,
398,1,0,0,0,428,422,1,0,0,0,429,74,1,0,0,0,430,432,5,96,0,0,431,433,3,77,
38,0,432,431,1,0,0,0,432,433,1,0,0,0,433,434,1,0,0,0,434,446,5,96,0,0,435,
437,5,34,0,0,436,438,3,79,39,0,437,436,1,0,0,0,437,438,1,0,0,0,438,439,1,
0,0,0,439,446,5,34,0,0,440,442,5,39,0,0,441,443,3,81,40,0,442,441,1,0,0,
0,442,443,1,0,0,0,443,444,1,0,0,0,444,446,5,39,0,0,445,430,1,0,0,0,445,435,
1,0,0,0,445,440,1,0,0,0,446,76,1,0,0,0,447,451,8,3,0,0,448,449,5,96,0,0,
449,451,5,96,0,0,450,447,1,0,0,0,450,448,1,0,0,0,451,452,1,0,0,0,452,450,
1,0,0,0,452,453,1,0,0,0,453,78,1,0,0,0,454,458,8,4,0,0,455,456,5,34,0,0,
456,458,5,34,0,0,457,454,1,0,0,0,457,455,1,0,0,0,458,459,1,0,0,0,459,457,
1,0,0,0,459,460,1,0,0,0,460,80,1,0,0,0,461,465,8,5,0,0,462,463,5,39,0,0,
463,465,5,39,0,0,464,461,1,0,0,0,464,462,1,0,0,0,465,466,1,0,0,0,466,464,
1,0,0,0,466,467,1,0,0,0,467,82,1,0,0,0,468,470,5,45,0,0,469,468,1,0,0,0,
469,470,1,0,0,0,470,474,1,0,0,0,471,473,3,93,46,0,472,471,1,0,0,0,473,476,
1,0,0,0,474,472,1,0,0,0,474,475,1,0,0,0,475,477,1,0,0,0,476,474,1,0,0,0,
477,486,5,46,0,0,478,480,3,93,46,0,479,478,1,0,0,0,480,481,1,0,0,0,481,479,
1,0,0,0,481,482,1,0,0,0,482,484,1,0,0,0,483,485,3,91,45,0,484,483,1,0,0,
0,484,485,1,0,0,0,485,487,1,0,0,0,486,479,1,0,0,0,486,487,1,0,0,0,487,84,
1,0,0,0,488,490,5,45,0,0,489,488,1,0,0,0,489,490,1,0,0,0,490,492,1,0,0,0,
491,493,3,93,46,0,492,491,1,0,0,0,493,494,1,0,0,0,494,492,1,0,0,0,494,495,
1,0,0,0,495,86,1,0,0,0,496,498,7,6,0,0,497,496,1,0,0,0,498,499,1,0,0,0,499,
497,1,0,0,0,499,500,1,0,0,0,500,501,1,0,0,0,501,502,6,43,0,0,502,88,1,0,
0,0,503,504,5,47,0,0,504,505,5,42,0,0,505,509,1,0,0,0,506,508,9,0,0,0,507,
506,1,0,0,0,508,511,1,0,0,0,509,510,1,0,0,0,509,507,1,0,0,0,510,512,1,0,
0,0,511,509,1,0,0,0,512,513,5,42,0,0,513,514,5,47,0,0,514,515,1,0,0,0,515,
516,6,44,0,0,516,90,1,0,0,0,517,519,7,7,0,0,518,520,7,8,0,0,519,518,1,0,
0,0,519,520,1,0,0,0,520,522,1,0,0,0,521,523,3,93,46,0,522,521,1,0,0,0,523,
524,1,0,0,0,524,522,1,0,0,0,524,525,1,0,0,0,525,92,1,0,0,0,526,527,7,9,0,
0,527,94,1,0,0,0,56,0,139,144,158,166,175,185,201,207,213,221,232,242,254,
266,269,282,285,298,301,304,316,319,332,335,348,351,354,374,377,398,401,
422,425,428,432,437,442,445,450,452,457,459,464,466,469,474,481,484,486,
489,494,499,509,519,524,1,6,0,0];


const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map( (ds, index) => new antlr4.dfa.DFA(ds, index) );

export default class QueryExprLexer extends antlr4.Lexer {

    static grammarFileName = "QueryExpr.g4";
    static channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];
	static modeNames = [ "DEFAULT_MODE" ];
	static literalNames = [ null, "'('", "')'", "'{'", "'}'", "'['", "']'", 
                         "'+'", "'-'", "'*'", "'/'", "'%'", "'^'", "'&'", 
                         "':'", "'?'", "'<'", "'>'", "'<='", "'>='", null, 
                         null, "'.'", "','" ];
	static symbolicNames = [ null, "LPAREN", "RPAREN", "LBRACE", "RBRACE", 
                          "LBRACKET", "RBRACKET", "PLUS", "MINUS", "MUL", 
                          "DIV", "MOD", "POW", "CONCAT", "COLON", "QMARK", 
                          "LT", "GT", "LTE", "GTE", "NEQ", "EQ", "DOT", 
                          "COMMA", "AND", "OR", "NOT", "WITH", "WITHOUT", 
                          "IN", "ESCAPED_IDENTIFIER", "UNESCAPED_IDENTIFIER", 
                          "NULL", "TRUE", "FALSE", "DATE", "TIME", "DATETIME", 
                          "STRING", "NUMBER", "INTEGER", "WHITESPACE", "COMMENT" ];
	static ruleNames = [ "LPAREN", "RPAREN", "LBRACE", "RBRACE", "LBRACKET", 
                      "RBRACKET", "PLUS", "MINUS", "MUL", "DIV", "MOD", 
                      "POW", "CONCAT", "COLON", "QMARK", "LT", "GT", "LTE", 
                      "GTE", "NEQ", "EQ", "DOT", "COMMA", "AND", "OR", "NOT", 
                      "WITH", "WITHOUT", "IN", "ESCAPED_IDENTIFIER", "UNESCAPED_IDENTIFIER", 
                      "NULL", "TRUE", "FALSE", "DATE", "TIME", "DATETIME", 
                      "STRING", "BACKTICK_QUOTE_LITERAL_VALUE", "DOUBLE_QUOTE_LITERAL_VALUE", 
                      "SINGLE_QUOTE_LITERAL_VALUE", "NUMBER", "INTEGER", 
                      "WHITESPACE", "COMMENT", "EXPONENT", "DIGIT" ];

    constructor(input) {
        super(input)
        this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.PredictionContextCache());
    }

    get atn() {
        return atn;
    }
}

QueryExprLexer.EOF = antlr4.Token.EOF;
QueryExprLexer.LPAREN = 1;
QueryExprLexer.RPAREN = 2;
QueryExprLexer.LBRACE = 3;
QueryExprLexer.RBRACE = 4;
QueryExprLexer.LBRACKET = 5;
QueryExprLexer.RBRACKET = 6;
QueryExprLexer.PLUS = 7;
QueryExprLexer.MINUS = 8;
QueryExprLexer.MUL = 9;
QueryExprLexer.DIV = 10;
QueryExprLexer.MOD = 11;
QueryExprLexer.POW = 12;
QueryExprLexer.CONCAT = 13;
QueryExprLexer.COLON = 14;
QueryExprLexer.QMARK = 15;
QueryExprLexer.LT = 16;
QueryExprLexer.GT = 17;
QueryExprLexer.LTE = 18;
QueryExprLexer.GTE = 19;
QueryExprLexer.NEQ = 20;
QueryExprLexer.EQ = 21;
QueryExprLexer.DOT = 22;
QueryExprLexer.COMMA = 23;
QueryExprLexer.AND = 24;
QueryExprLexer.OR = 25;
QueryExprLexer.NOT = 26;
QueryExprLexer.WITH = 27;
QueryExprLexer.WITHOUT = 28;
QueryExprLexer.IN = 29;
QueryExprLexer.ESCAPED_IDENTIFIER = 30;
QueryExprLexer.UNESCAPED_IDENTIFIER = 31;
QueryExprLexer.NULL = 32;
QueryExprLexer.TRUE = 33;
QueryExprLexer.FALSE = 34;
QueryExprLexer.DATE = 35;
QueryExprLexer.TIME = 36;
QueryExprLexer.DATETIME = 37;
QueryExprLexer.STRING = 38;
QueryExprLexer.NUMBER = 39;
QueryExprLexer.INTEGER = 40;
QueryExprLexer.WHITESPACE = 41;
QueryExprLexer.COMMENT = 42;



